<template>
    <va-create-layout>
        <ShipmentEventShipmentItem-form
            :title="title"
            :item="item"
        ></ShipmentEventShipmentItem-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"],
};
</script>
